import { useState, useCallback } from 'react';

/**
 * Custom hook for handling scroll navigation behavior
 * @param onSetActive Callback function to update active section
 */
export function useNavScroll(onSetActive: (path: string) => void) {
  // State to temporarily disable scroll spy during manual navigation
  const [disableSpy, setDisableSpy] = useState(false);

  /**
   * Handles click events on navigation items
   * - Temporarily disables scroll spy
   * - Updates active section
   * - Updates URL hash
   */
  const handleClick = useCallback(
    (listPath: string) => {
      // Disable spy to prevent interference during manual navigation
      setDisableSpy(true);

      // Update active section
      onSetActive(listPath);

      // Update URL hash
      window.history.replaceState(null, '', `#${listPath}`);

      // Re-enable spy after scroll animation completes
      setTimeout(() => {
        setDisableSpy(false);
      }, 580);
    },
    [onSetActive]
  );

  /**
   * Handles scroll spy active state changes
   * - Updates active section
   * - Updates URL hash
   */
  const handleSetActive = useCallback(
    (listPath: string) => {
      onSetActive(listPath);
      window.history.replaceState(null, '', `#${listPath}`);
    },
    [onSetActive]
  );

  return {
    disableSpy,
    handleClick,
    handleSetActive,
  };
}
